import {
  prepareSingleStatusResponse,
  prepareStatusResponses
} from './helpers';

export const SET_ERROR = 'presence/SET_ERROR';
export const SET_PRESENCE_STATUS = 'presence/SET_PRESENCE_STATUS';
export const UPDATE_MODULE_STATUS = 'presence/UPDATE_MODULE_STATUS';
export const UPDATE_USER_STATUS_ERROR = 'presence/UPDATE_USER_STATUS_ERROR';

function updateStatus(status) {
  return {
    type: UPDATE_MODULE_STATUS,
    payload: {
      status
    }
  };
}

function setError(error) {
  return {
    type: SET_ERROR,
    payload: {
      error
    }
  };
}

function setPresenceStatus(status) {
  return {
    type: SET_PRESENCE_STATUS,
    payload: {
      status
    }
  };
}

/**
 * active: Indicates that the user is "active" in the system for the giventtl or until another event is received.
 * inactive: Indicates that the user should be considered "inactive" for the given ttl or until another event
 *  is received
 * dnd: Indicates a desire by the user to not be disturbed for the given ttl.A TTL= 0 indicates canceling current
 * dnd state
  * ooo: Indicates that the user is "out of office" for the given ttl.A TTL= 0 indicates canceling current ooo state
 */
/**
 * @type {('active', 'inactive', 'dnd', 'ooo')} EventType - Types of user statuses
 */

/**
 * Sets the current user's status
 * @param {EventType} eventType
 * @param {number} ttl Time To Live for the event in seconds.
 * @param {object} spark
 * @returns {Thunk}
 */
export function setUserPresenceStatus(eventType, ttl, spark) {
  return (dispatch) => {
    dispatch(updateStatus({isSettingUserStatus: true}));

    return spark.internal.presence.setStatus(eventType, ttl)
      .then(() =>
        dispatch(updateStatus({isSettingUserStatus: false})))
      .catch((error) =>
        dispatch(setError(error)));
  };
}

/**
 * Async requests a specific user's status
 * @param {array | string} userIds
 * @param {object} spark
 * @returns {Thunk}
 */
export function getCurrentPresenceStatus(userIds, spark) {
  const subjects = Array.isArray(userIds) ? userIds : [userIds];

  return (dispatch) =>
    spark.internal.presence.list(subjects)
      .then((presenceResponse) => dispatch(setPresenceStatus(presenceResponse.statusList)));
}

/**
 * Fetches and subscribes to a user's presence status
 * @param {array | string} userIds
 * @param {object} spark
 * @returns {Thunk}
 */
export function subscribeToPresenceUpdates(userIds, spark) {
  return (dispatch, getState) => {
    const subjects = Array.isArray(userIds) ? userIds : [userIds];
    const {presence} = getState();
    const newUserIds = subjects.filter((subject) => !presence.hasIn(['items', subject]));

    if (newUserIds.length === 0) {
      return Promise.resolve();
    }
    const emptyStatuses = newUserIds.map((id) => ({subject: id, status: false}));

    dispatch(setPresenceStatus(prepareStatusResponses(emptyStatuses)));
    // normal subscription ttl in seconds
    const subscriptionTtl = 600;

    return spark.internal.presence.subscribe(newUserIds, subscriptionTtl)
      .then((presenceResponse) => {
        spark.internal.mercury.on('event:apheleia.subscription_update', (event) => {
          dispatch(setPresenceStatus(prepareSingleStatusResponse(event.data)));
        });

        return dispatch(setPresenceStatus(prepareStatusResponses(presenceResponse.responses)));
      });
  };
}

/**
 * Tells the service to stop sending status updates
 * @param {array | string} userIds
 * @param {object} spark
 * @returns {Thunk}
 */
export function unsubscribeFromPresenceUpdates(userIds, spark) {
  const subjects = Array.isArray(userIds) ? userIds : [userIds];

  return (dispatch) =>
    spark.internal.presence.unsubscribe(subjects)
      .then(() => {
        // Setting status to undefined clears the subject from items
        const clearStatus = {};

        subjects.forEach((subject) => {
          clearStatus[subject] = undefined;
        });

        return dispatch(setPresenceStatus(clearStatus));
      });
}
